module.exports = __webpack_public_path__ + "media/images/logo_w-f14b3857ccff30d9c2cfae69475eee09.png";